import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { FAQS } from '../data/landing';
export function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="w-full bg-white py-10 sm:py-16" data-id="element-56" data-mp="1bmllj4fjvriw">
      <div className="mx-auto max-w-3xl px-4 sm:px-6" data-id="element-57" data-mp="1gityqca6tanf">
        <h2 className="text-center text-2xl font-black text-neutral-900 sm:text-3xl lg:text-4xl" data-id="element-58" data-mp="1glgc4sjrekdk">
          Preguntas frecuentes
        </h2>
        <p className="mt-3 text-center text-base text-neutral-600" data-id="element-59" data-mp="28b1fdcpp0n1t">
          Lo que todos quieren saber antes de empezar.
        </p>

        <div className="mt-8 space-y-3" data-id="element-60" data-mp="1uj4plfbhyp8l">
          {FAQS.map((faq, i) => {
          const isOpen = open === i;
          return <div key={i} className="overflow-hidden rounded-2xl border border-neutral-200 bg-neutral-50" data-id="element-61" data-mp="1zg4uvo0ivnyn" data-mpi={i}>
                <button onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left" data-id="element-62" data-mp="2rysainwr2asc">
                  <span className="text-base font-bold text-neutral-900" data-id="element-63" data-mp="14vk4jt52pibr">
                    {faq.pregunta}
                  </span>
                  <ChevronDownIcon className={`h-5 w-5 shrink-0 text-neutral-500 transition-transform ${isOpen ? 'rotate-180' : ''}`} data-id="element-64" data-mp="1ektup3gcwqx8" />
                </button>
                <AnimatePresence initial={false} data-id="element-65" data-mp="19t2dvkn05zka">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.25
              }} data-id="element-66" data-mp="1oihy0hs136r0">
                      <p className="px-5 pb-5 text-sm leading-relaxed text-neutral-600" data-id="element-67" data-mp="1sis5jyvgy57z">
                        {faq.respuesta}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}